// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VeeValidate from 'vee-validate'

import { router } from './router'
import { store } from './store'

import Toast from './plugins/toast'
import Alert from './plugins/alert'
import Panel from './plugins/panel'
// import SignalR from './plugins/signalr'

import Debounce from 'v-debounce'
import { VueSlideoutPanel } from 'vue2-slideout-panel'

import Vuex from 'vuex'

import VueLodash from 'vue-lodash'
import lodash from 'lodash'

// Import layouts
import AdminLayout from './components/layouts/AdminLayout'
import LoginLayout from './components/layouts/LoginLayout'

import './assets/styles/app.scss'

Vue.use(Toast)
Vue.use(Alert)
Vue.use(Panel)
// Vue.use(SignalR)

Vue.use(Vuex)
Vue.use(require('vue-moment'))
Vue.use(VeeValidate)

// Loadash is used to compare objects reliably, see AgileTableActions filter
Vue.use(VueLodash, { name: 'custom', lodash: lodash })

// Directives
Vue.directive('debounce', Debounce)

// Layouts
Vue.component('admin-layout', AdminLayout)
Vue.component('login-layout', LoginLayout)
Vue.component('slideout-panel', VueSlideoutPanel)

Vue.config.productionTip = false

window.isElectron = function () {
  return 'Bridge' in window
}

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

/* eslint-disable no-new, no-unused-vars */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js